import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

class ActivityTracker {
  constructor() {
    this.currentActivities = new Map();
  }

  async startActivity(feature, action = 'view', metadata = null) {
    const sessionId = Math.random().toString(36).substring(2);
    const path = window.location.pathname;

    try {
      const requestData = {
        action_type: action,
        feature_name: feature,
        page_path: path,
        session_id: sessionId,
        metadata: metadata ? JSON.stringify(metadata) : null
      };

      const response = await axios.post(`${API_BASE_URL}/activity/log`, requestData, { 
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        }
      });

      this.currentActivities.set(feature, sessionId);
      return sessionId;
    } catch (error) {
      console.error('[ActivityTracker] Failed to log activity start:', error);
      if (error.response) {
        console.error('Error response:', error.response.data);
        console.error('Error status:', error.response.status);
      }
      throw error;
    }
  }

  async endActivity(feature) {
    const sessionId = this.currentActivities.get(feature);
    if (!sessionId) {
      return;
    }

    try {
      const response = await axios.post(`${API_BASE_URL}/activity/end`, {
        feature_name: feature,
        session_id: sessionId
      }, { 
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        }
      });

      this.currentActivities.delete(feature);
    } catch (error) {
      console.error('[ActivityTracker] Failed to log activity end:', error);
      if (error.response) {
        console.error('Error response:', error.response.data);
        console.error('Error status:', error.response.status);
      }
      throw error;
    }
  }

  trackPageView(feature) {
    let sessionId = null;

    // Start tracking immediately
    this.startActivity(feature, 'view').then(sid => {
      sessionId = sid;
    }).catch(error => {
      console.error('[ActivityTracker] Failed to start page view tracking:', error);
    });

    // Return a cleanup function that will be called when the component unmounts
    return () => {
      if (sessionId) {
        this.endActivity(feature).catch(error => {
          console.error('[ActivityTracker] Failed to end page view tracking:', error);
        });
      }
    };
  }

  async trackFeatureUse(feature, metadata = null) {
    let sessionId;
    try {
      sessionId = await this.startActivity(feature, 'use', metadata);
    } catch (error) {
      console.error('[ActivityTracker] Failed to start feature use tracking:', error);
      throw error;
    }

    return () => {
      this.endActivity(feature).catch(error => {
        console.error('[ActivityTracker] Failed to end feature use tracking:', error);
      });
    };
  }
}

export const activityTracker = new ActivityTracker(); 